import { useDispatch } from 'react-redux'

import { setFeedback as setFeedbackAction } from '../container/home'

export const useFeedback = () => {
  const dispatch = useDispatch()

  const setFeedback = (phrase, error = true, title, triggerPath) =>
    dispatch(setFeedbackAction({ error, phrase, title, triggerPath }))

  return { setFeedback }
}
